// ** React Imports
import type { ElementType } from 'react';

// ** Types
import type { NavLink, NavGroup, HorizontalNavItemsType, NavSectionTitle } from '../../../../types';

// ** Custom Navigation Components
import HorizontalNavLink from './HorizontalNavLink';
import HorizontalNavGroup from './HorizontalNavGroup';
import HorizontalNavSectionTitle from './HorizontalNavSectionTitle';
import CanViewNavLink from '../../CanViewNavLink';

interface Props {
  hasParent?: boolean;
  horizontalNavItems?: HorizontalNavItemsType;
  /** Called when a menu item is selected so the popup menu can close. */
  onCloseMenu?: () => void;
}
const resolveComponent = (item: NavGroup | NavLink | NavSectionTitle) => {
  if ((item as NavSectionTitle).sectionTitle) return HorizontalNavSectionTitle;
  if ((item as NavGroup).children) return HorizontalNavGroup;
  return HorizontalNavLink;
};

const HorizontalNavListItems = (props: Props) => {
  const RenderMenuItems = props.horizontalNavItems?.map(
    (item: NavGroup | NavLink | NavSectionTitle, index: number) => {
      const TagName: ElementType = resolveComponent(item);

      return (
        <CanViewNavLink key={index} navLink={item}>
          <TagName {...props} item={item} onCloseMenu={props.onCloseMenu} />
        </CanViewNavLink>
      );
    },
  );

  return <>{RenderMenuItems}</>;
};

export default HorizontalNavListItems;
